import React from "react";
import { Routes, Route } from "react-router-dom";
import { EditarPerfil } from "../pages/Auth/Pasajero/EditarPerfil";
import { Inicio } from "../pages/Auth/Pasajero/Inicio";
import { NuevoViaje } from "../pages/Auth/Pasajero/NuevoViaje";
import { NuevoViaje1 } from "../pages/Auth/Pasajero/NuevoViaje1";
import { NuevoViaje2 } from "../pages/Auth/Pasajero/NuevoViaje2";
import { NuevoViaje3 } from "../pages/Auth/Pasajero/NuevoViaje3";
import { NuevoViaje4 } from "../pages/Auth/Pasajero/NuevoViaje4";
import { NuevoViaje5 } from "../pages/Auth/Pasajero/NuevoViaje5";
import { NuevoViaje6 } from "../pages/Auth/Pasajero/NuevoViaje6";
import { Error404 } from "../pages/Public";
import { HistorialViajes } from "../pages/Auth/Pasajero/HistorialViajes";

export function AuthPasajeroRouter() {
  return (
    <Routes>
      <Route path="/Pasajero/EditarPerfil/*" element={<EditarPerfil />} />
      <Route path="/Pasajero/Inicio/*" element={<Inicio />} />
      <Route path="/Pasajero/NuevoViaje/*" element={<NuevoViaje />} />
      <Route path="/Pasajero/NuevoViaje1/*" element={<NuevoViaje1 />} />
      <Route path="/Pasajero/NuevoViaje2/*" element={<NuevoViaje2 />} />
      <Route path="/Pasajero/NuevoViaje3/*" element={<NuevoViaje3 />} />
      <Route path="/Pasajero/NuevoViaje4/*" element={<NuevoViaje4 />} />
      <Route path="/Pasajero/NuevoViaje5/*" element={<NuevoViaje5 />} />
      <Route path="/Pasajero/NuevoViaje6/*" element={<NuevoViaje6 />} />
      <Route path="Pasajero/HistorialViajes" element={<HistorialViajes />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
